module.exports = __webpack_public_path__ + "img/Azores Islands.801de342.svg";